import { render, staticRenderFns } from "./DocumentTemplateDetailListing.vue?vue&type=template&id=32878990"
import script from "./DocumentTemplateDetailListing.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetailListing.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateDetailListing.vue?vue&type=style&index=0&id=32878990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports